// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__90ZE0","rootNoMargin":"styles_rootNoMargin__2y0ud"};